import { makeAutoObservable, runInAction } from 'mobx';

class OrganizationStore {
  feed = [];
  members = [];
  loading = false;
  membersLoading = false;
  searchLoading = false;
  searchResults = [];
  error = null;
  feedPage = 1;
  membersPage = 1;
  hasMoreFeed = true;
  hasMoreMembers = true;
  totalMembers = 0;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  async searchOrganizations(query) {
    if (!query || query.trim().length < 2) {
      runInAction(() => {
        this.searchResults = [];
        this.searchLoading = false;
      });
      return;
    }

    try {
      runInAction(() => {
        this.searchLoading = true;
        this.error = null;
      });

      const response = await this.rootStore.authenticatedApiCall(
        `api/organizations?search=${encodeURIComponent(query.trim())}`,
        {},
        'GET',
        undefined,
        false,
        false,
        true // nonAuthenticatedCall = true for organization search
      );

      runInAction(() => {
        this.searchResults = response || [];
        this.searchLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.message;
        this.searchLoading = false;
        this.searchResults = [];
      });
      console.error('Error searching organizations:', error);
    }
  }

  clearSearchResults() {
    this.searchResults = [];
    this.searchLoading = false;
    this.error = null;
  }

  async fetchOrgFeed({ page = 1, append = false, organizationId }) {
    try {
      runInAction(() => {
        this.loading = true;
        this.error = null;
        if (!append) {
          this.feed = [];
          this.feedPage = 1;
          this.hasMoreFeed = true;
        }
      });

      const response = await this.rootStore.authenticatedApiCall(
        `api/organizations/${organizationId}/feed?page=${page}&limit=20`
      );

      runInAction(() => {
        if (append) {
          this.feed = [...this.feed, ...response.items];
        } else {
          this.feed = response.items;
        }
        this.feedPage = page + 1;
        this.hasMoreFeed = response.hasMore;
        this.loading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.message;
        this.loading = false;
      });
      throw error;
    }
  }

  async fetchMembers({ page = 1, append = false, organizationId }) {
    try {
      runInAction(() => {
        this.membersLoading = true;
        this.error = null;
        if (!append) {
          this.members = [];
          this.membersPage = 1;
          this.hasMoreMembers = true;
        }
      });

      const response = await this.rootStore.authenticatedApiCall(
        `api/organizations/${organizationId}/members?page=${page}&limit=50`
      );

      runInAction(() => {
        if (append) {
          this.members = [...this.members, ...response.members];
        } else {
          this.members = response.members;
        }
        this.membersPage = page + 1;
        this.hasMoreMembers = response.hasMore;
        this.totalMembers = response.totalMembers;
        this.membersLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.message;
        this.membersLoading = false;
      });
      throw error;
    }
  }

  clearFeed() {
    this.feed = [];
    this.feedPage = 1;
    this.hasMoreFeed = true;
    this.error = null;
  }

  clearMembers() {
    this.members = [];
    this.membersPage = 1;
    this.hasMoreMembers = true;
    this.totalMembers = 0;
    this.error = null;
  }
}

export { OrganizationStore }; 